<template>
  <router-view/>
</template>

<style>
#app{
  background-color: var(--main-color)
}
</style>
